export function getTeamAverage(members, team, field) {
    if (!Array.isArray(members)) return 0

    const teamMembers = members.filter(member => member?.gameTeam === team)
    if (teamMembers.length === 0) return 0

    // 缺失的统计值按 0 处理，避免单条脏数据让整队结果变成 NaN。
    const total = teamMembers.reduce((sum, member) => sum + (Number(member?.[field]) || 0), 0)
    return (total / teamMembers.length).toFixed(1)
}

